var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoXl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 0H15C6.71573 0 0 6.71573 0 15V81C0 89.2842 6.71573 96 15 96H81C89.2842 96 96 89.2842 96 81V15C96 6.71573 89.2842 0 81 0Z",
    fill: "#58C5C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9999 15V81C96.0023 82.9702 95.6155 84.9215 94.8616 86.7417C94.1077 88.562 93.0016 90.2153 91.6068 91.6069L4.39307 4.39314C5.78458 2.99836 7.43795 1.89225 9.25821 1.13835C11.0785 0.384438 13.0297 -0.00241408 14.9999 1.13345e-05H80.9999C84.9782 1.13345e-05 88.7935 1.58036 91.6065 4.39341C94.4196 7.20645 95.9999 11.0218 95.9999 15Z",
    fill: "#F9E600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6287 49.753L20.9925 61.3893H20.9916L0 40.3968V17.1243L32.6287 49.753Z",
    fill: "#338ECD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3903 20.9916L49.754 32.6278L17.1262 0H40.3987L61.3903 20.9916Z",
    fill: "#842B7C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.754 32.625L32.625 49.7531L0 17.1244V15C0 11.0217 1.58035 7.20644 4.3934 4.3934C7.20644 1.58035 11.0217 0 15 0L17.1262 0L49.754 32.625Z",
    fill: "#6559A7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7532 32.6288L61.3894 20.9926L96 55.6032V78.8757L49.7532 32.6288Z",
    fill: "#FDC017"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9917 61.3891L32.6279 49.7538L78.8739 95.9997H55.6014L20.9917 61.3891Z",
    fill: "#C8202D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.625 49.7541L49.7531 32.625L96 78.8756V81C96 84.9782 94.4196 88.7935 91.6066 91.6066C88.7935 94.4196 84.9782 96 81 96H78.8737L32.625 49.7541Z",
    fill: "#D06D2B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M48.0001 88.0507C67.056 88.0507 82.5038 72.6028 82.5038 53.5469C82.5038 34.4911 67.056 19.0432 48.0001 19.0432C28.9442 19.0432 13.4963 34.4911 13.4963 53.5469C13.4963 72.6028 28.9442 88.0507 48.0001 88.0507Z",
    fill: "#323F53"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0001 82.5035C67.056 82.5035 82.5038 67.0557 82.5038 47.9998C82.5038 28.9439 67.056 13.496 48.0001 13.496C28.9442 13.496 13.4963 28.9439 13.4963 47.9998C13.4963 67.0557 28.9442 82.5035 48.0001 82.5035Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48 79.3294C65.3027 79.3294 79.3294 65.3028 79.3294 48.0001C79.3294 30.6973 65.3027 16.6707 48 16.6707C30.6973 16.6707 16.6707 30.6973 16.6707 48.0001C16.6707 65.3028 30.6973 79.3294 48 79.3294Z",
    fill: "#323F53"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48 76.1126C63.5263 76.1126 76.1128 63.526 76.1128 47.9998C76.1128 32.4735 63.5263 19.887 48 19.887C32.4737 19.887 19.8872 32.4735 19.8872 47.9998C19.8872 63.526 32.4737 76.1126 48 76.1126Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71.0455C60.7277 71.0455 71.0456 60.7276 71.0456 47.9998C71.0456 35.2721 60.7277 24.9542 48 24.9542C35.2722 24.9542 24.9543 35.2721 24.9543 47.9998C24.9543 60.7276 35.2722 71.0455 48 71.0455Z",
    fill: "#323F53"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0001 48.0001L38.8679 38.8679C41.3898 36.346 44.4339 35.0851 48.0001 35.0851V48.0001Z",
    fill: "#842B7C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48.0001H35.085C35.085 44.4339 36.3459 41.3898 38.8678 38.8679L48 48.0001Z",
    fill: "#645BA7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48L38.8678 57.1322C36.3459 54.6103 35.085 51.5662 35.085 48H48Z",
    fill: "#338ECB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0001 48V60.915C44.4339 60.915 41.3898 59.6541 38.8679 57.1322L48.0001 48Z",
    fill: "#58C5C8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48L57.1322 57.1322C54.6103 59.6541 51.5662 60.915 48 60.915V48Z",
    fill: "#C8202D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48H60.915C60.915 51.5662 59.6541 54.6103 57.1322 57.1322L48 48Z",
    fill: "#D06D2B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48.0001L57.1322 38.8679C59.6541 41.3898 60.915 44.4339 60.915 48.0001H48Z",
    fill: "#FBBE18"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48.0001V35.0851C51.5662 35.0851 54.6103 36.346 57.1322 38.8679L48 48.0001Z",
    fill: "#F9E700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoXl);
export default __webpack_public_path__ + "static/media/logo_xl.db8350ba48100ce8fbbf7d53c6fb2d99.svg";
export { ForwardRef as ReactComponent };